/**
 * Demo 页面包装器（公共组件）
 *
 * 为所有 Demo 页面提供统一的返回按钮和布局
 */

import React from 'react';
import { Button } from '@bedrock/components';
import { useHistory } from 'react-router-dom';

interface DemoWrapperProps {
  children: React.ReactNode;
  title?: string;
}

export default function DemoWrapper({ children, title }: DemoWrapperProps) {
  const history = useHistory();

  return (
    <div className="bg-bg-1 min-h-screen bg-white relative">
      <div className="flex items-center gap-4 mb-6">
        <Button onClick={() => history.push('/demos')}>← 返回 Demo 列表</Button>
        {title && <h1 className="text-xl font-semibold text-color-1">{title}</h1>}
      </div>
      {children}
    </div>
  );
}
